import styled from 'styled-components';

import { HERO_FONT_BODY, LandingHero } from 'constants/landing-hero';

export const PageWrap = styled.div`
  position: relative;
  min-height: 100vh;
  overflow-x: clip;
  background: ${LandingHero.pageBottom};
  background-image: ${LandingHero.pageGradient};
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: ${LandingHero.textBody};
  font-family: ${HERO_FONT_BODY};
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
`;
